.panel {
  background: var(--panel);
  margin: 1rem 1.5rem;
  border: 1px solid var(--border);
  border-radius: 12px;
  overflow: hidden;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.25rem 0.25rem;
  gap: 1rem;
}

.title {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 600;
}

.hint {
  font-size: 0.8rem;
  color: var(--muted);
  padding: 0 1.25rem 0.5rem;
  margin: 0;
}

.download {
  background: var(--panel);
  color: var(--text);
  border: 1px solid var(--border);
  border-radius: 999px;
  padding: 0.35rem 0.85rem;
  font-size: 0.85rem;
  font-weight: 600;
}

.download:hover:not(:disabled) {
  background: var(--bg);
}

.download:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.list {
  padding: 0 0 0.75rem;
}

.row {
  display: grid;
  grid-template-columns: 2rem 1fr auto auto auto auto;
  align-items: center;
  gap: 1rem;
  padding: 0.65rem 1.25rem;
  border-top: 1px solid var(--border);
}

.row:first-child {
  border-top: 0;
}

.rank {
  color: var(--muted);
  font-weight: 600;
  font-size: 0.95rem;
}

.dateButton {
  background: none;
  border: 0;
  padding: 0;
  margin: 0;
  font: inherit;
  text-align: left;
  color: var(--accent);
  cursor: pointer;
}

.dateButton:hover {
  text-decoration: underline;
}

.value {
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.peopleLabel {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.85rem;
  color: var(--muted);
}

.peopleLabelText {
  white-space: nowrap;
}

.peopleInput {
  width: 4.5rem;
  padding: 0.3rem 0.5rem;
  border: 1px solid var(--border);
  border-radius: 6px;
  font-variant-numeric: tabular-nums;
}

.peopleInput:focus {
  outline: 2px solid var(--accent);
  outline-offset: -1px;
}

.perPerson {
  font-size: 0.85rem;
  color: var(--muted);
  font-variant-numeric: tabular-nums;
  min-width: 9ch;
  text-align: right;
}

.savingBadge {
  font-size: 0.75rem;
  color: var(--muted);
  min-width: 5ch;
  text-align: right;
}

@media (max-width: 720px) {
  .row {
    grid-template-columns: 1fr 1fr;
    grid-auto-rows: auto;
  }
  .rank {
    grid-row: 1;
  }
  .dateButton {
    grid-row: 1;
  }
  .value {
    grid-row: 2;
    grid-column: 1 / -1;
  }
  .peopleLabel {
    grid-row: 3;
  }
  .perPerson {
    grid-row: 3;
  }
  .savingBadge {
    grid-row: 4;
    grid-column: 1 / -1;
  }
}
